import { ColDef } from 'ag-grid-community'
import { ColDefWithLoading } from 'components/core-v2'

export const COLUMN_DEFS: ColDefWithLoading[] = [
  {
    headerName: 'Asset Name',
    field: 'assetName',
    minWidth: 280,
    flex: 0.6,
    cellStyle: { display: 'flex' },
    loadingCellWidth: 'xl'
  },
  {
    headerName: 'Asset ID',
    field: 'assetId',
    minWidth: 140,
    flex: 0.2
  },

  {
    headerName: 'Number of Units',
    field: 'shares',
    minWidth: 100,
    flex: 0.2,
    type: 'rightAligned'
  }
]

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: false,
  unSortIcon: true
}
